import { render, staticRenderFns } from "./BarBasic.vue?vue&type=template&id=b5bb0d38"
import script from "./BarBasic.vue?vue&type=script&lang=js"
export * from "./BarBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports